module.exports = __webpack_public_path__ + "media/WoveonOpenConvo.f3d8fb05.mp4";